import React from 'react';
import { ShieldCheck, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-gray-300 py-20 px-6 pt-24">
      <div className="max-w-3xl mx-auto">
        <button 
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-[#4ade80] mb-8 hover:opacity-80 transition-opacity"
        >
          <ArrowLeft size={20} />
          Back
        </button>

        <div className="flex items-center gap-3 mb-6">
          <ShieldCheck className="text-[#4ade80]" size={32} />
          <h1 className="text-3xl font-bold text-white">Privacy Policy</h1>
        </div>

        <div className="space-y-6 leading-relaxed">
          <p>Last Updated: May 12, 2026</p>
          
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">1. Information We Collect</h2>
            <p>We do not collect personal identification information directly. However, our verification partners and CPA networks may collect data such as device ID, IP address, and browser type to ensure reward eligibility.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">2. How Data is Used</h2>
            <p>Data collected by our partners is used solely for the purpose of offer completion verification and fraud prevention. We do not sell your personal information to third parties.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">3. Cookies</h2>
            <p>We use essential cookies to maintain your session and track offer progress to ensure you receive your rewards.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">4. Contact Us</h2>
            <p>If you have questions about our privacy practices, please reach out via our Support channel.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;